export const SAAS_V1 = 'saas-v1';
export const BIDDING_DISABLED = 'bidding-disabled';
export const DELIVERY_SLA = 'delivery-sla';
export const DISABLE_AVAILABILIY = 'disable-customer-availability';
export const LTL_MARKETPLACE = 'ltl-marketplace';
export const SHIPPER_BIDDING_V1 = 'shipper-bidding-v1';
export const BROKER = 'broker';
export const ACCOUNTING_V2 = 'accounting-v2';
export const ADVANCED_SCHEDULING = 'advanced-scheduling';
export const ASSET_HEAVY = 'asset-heavy';
export const PDF_IMPORT_V1 = 'pdf-import-v1';
export const GENERAL_ELECTRIC_JSON_IMPORT = 'general-electric-json-import-v1';
export const PLAN_PAGE_LOADBOARD = 'plan-page-load-board';
export const PLAN_PAGE_NETWORK_ROUTES = 'plan-page-network-routes';
export const PLAN_PAGE_PAST_SCHEDULED = 'plan-page-past-scheduled';
export const PLAN_PAGE_UNSCHEDULED = 'plan-page-unscheduled';
export const CDS_TIMEFRAME_EXPORT = 'cds-timeframe-export';
export const CUSTOM_CUSTOMER_COMMS_RANGE = 'custom-customer-comms-range';
export const WMS = 'wms';
export const ONWARD_HANDLED_QUOTES = 'onward-handled-quotes';
export const DRIVER_PAYMENTS = 'driver-payments';
export const PLAN_PAGE_REMOVE_WITHOUT_UNLOCK = 'plan-page-remove-without-unlock';
export const ADD_ORDER_TO_COMPLETED_ROUTE = 'add-order-to-completed-route';
export const SHIPPER_RATE_SHOP = 'shipper-rate-shop';
export const PLAN_PAGE_SHOW_RATES = 'plan-page-show-rates';
export const ROUTE_CUSTOM_MAP_MARKERS = 'route-custom-map-markers';
export const SALESFORCE_ROUTE_EXPORT = 'salesforce-route-export';
export const GE_DELIVERS_ROUTE_EXPORT = 'ge-delivers-route-export';
export const TIMEFRAME_CONFIRMATION_PREFERENCE = 'timeframe-confirmation-preference';
export const INGEST_MANIFESTS = 'ingest-manifests';
export const RESEND_UNCONFIRMED_TIMEFRAME_CALLS = 'resend-unconfirmed-timeframe-calls';
export const PRESCHEDULED_HIGHLIGHT = 'prescheduled-highlight';
export const SHOW_REC_EQUIPMENT_SHAPE_TAGS = 'show-rec-equipment-shape-tags';
export const AUTO_SPLIT_ITEM_QUANTITY = 'auto-split-item-quantity';
export const AUTO_ALLOCATE_FORWARD_STOCKED = 'auto-allocate-forward-stocked';
export const SKIP_COMINGLED_STOPS = 'skip-comingled-stops';
export const ROUTE_RETURNS_MANIFEST = 'route-returns-manifest';
export const APPROXIMATE_FACILITY_LOCATION = 'approximate-facility-location';
export const MASTERBRAND_CUSTOM_EXPORT = 'masterbrand-custom-export';
export const PELOTON_CUSTOM_EXPORT = 'peloton-custom-export';
export const CATALOG_SERVICE_RATES = 'catalog-service-rates';
export const SPLIT_ORDERS = 'split-orders';
